//
document.addEventListener('crJQActivated', function (e) {
  jqCR('#pickup-date-start').on('click', function(){
    setTimeout(function(){
      console.log('Open')
      jqCR('.picker__nav--next').click()
      jqCR('.picker__nav--prev').click()
    }, 400)
    
  })
})


document.addEventListener('crPickupActivated', function (e) {
  jqCR.validator.addMethod("phone10", function(value, element) {
    // Standard 10-digit check: allows empty (handled by required) or 10 digits
    return this.optional(element) || /^\d{10}$/.test(value);
  }, "Please enter a valid 10-digit phone number.");
  setTimeout(function(){
    jqCR('#pickup-number').rules("add", {
      required: true,
      phone10: true,
      messages: {
          required: "Pickup number is required.",
          phone10: "Please enter a valid phone number"
      }
    });
    
  }, 500)  
})

// **** Better way to set special products in one place **** ////
var specialProduct1 = false;
var specialProduct2 = false;
var specialProduct3 = false;
var noSpecialProduct3 = false;
var specialProduct4 = false;
var specialProduct5 = false;
var specialProduct6 = false;
var specialProduct7 = false;
var specialProduct11 = false;
var specialProduct12 = false;

for (var i = 0; i < crItems.length; i++) {
  var itemCollections = crItems[i].collections || ""; // Handle null/undefined
  var itemTitle = crItems[i].name;
  if (itemTitle === 'Pickup Instore') continue;

  console.log('-->', itemTitle);

  if (itemCollections.toLowerCase().indexOf('Pastry Range'.toLowerCase()) > -1) {
    specialProduct1 = true;
  }

  if (
    (itemTitle.toLowerCase().indexOf('Twice Baked Hot Cross-ant'.toLowerCase()) > -1) ||
    (itemTitle.toLowerCase().indexOf('Hot Cross Cinnamon Scroll'.toLowerCase()) > -1)   
  ) {
    console.log('========================================')    
    specialProduct2 = true;
  }

  if (
    (itemTitle.toLowerCase().indexOf('Traditional Hot Cross Buns - 6 pack'.toLowerCase()) > -1) ||
    (itemTitle.toLowerCase().indexOf('Mocha Cross Bun'.toLowerCase()) > -1)    
  ) {
    specialProduct3 = true;
  } else {
    noSpecialProduct3 = true;
  }

  if (
    (itemTitle.toLowerCase().indexOf('Egg Salad Sandwich Platter'.toLowerCase()) > -1) ||
    (itemTitle.toLowerCase().indexOf('Salad Sandwich Platter'.toLowerCase()) > -1) ||
    (itemTitle.toLowerCase().indexOf('Classic BLT Sandwich Platter'.toLowerCase()) > -1) ||
    (itemTitle.toLowerCase().indexOf('Chicken Sandwich Platter'.toLowerCase()) > -1)
  ) {
    specialProduct4 = true;
  }

  if (itemCollections.toLowerCase().indexOf("Father's Day Hamper".toLowerCase()) > -1) {
    specialProduct5 = true;
  }

  if (itemCollections.toLowerCase().indexOf("Easter".toLowerCase()) > -1) {
    specialProduct6 = true;
  }

  // if (itemCollections.toLowerCase().indexOf('Special Product 11'.toLowerCase()) > -1) {
  //   specialProduct11 = true;
  // }
  // if (itemCollections.toLowerCase().indexOf('Christmas'.toLowerCase()) > -1) {
  //   specialProduct7 = true;
  // }
}
console.log('========================================', specialProduct2)  
for (var i = 0; i < stores.length; i++) {
  if (!stores[i]) continue;
  var storeName = stores[i].name.toLowerCase();
  var storeId = stores[i].storeID;

  if (specialProduct4 === true) {
    if (storeId === 5280 || storeId === 9464) {
      stores.splice(i, 1);
      i--; // Adjust index after removal
    }
  }

  if ((specialProduct3 === false || noSpecialProduct3 === true) ) {
    if (storeId === 1032 || storeId === 218  || storeId === 4601 || storeId === 6070) {
      delete stores[i];
    }
  }

  if ((specialProduct6 === false) ) {
    if (storeId === 1032 || storeId === 218  || storeId === 4601 || storeId === 6070) {
      delete stores[i];
    }
  }
}

var crDateCallback = function(picker, selectedStore, blackoutdatesCollection) {
  if (!selectedStore) return;
  var t = new Date();
  var currentDay = t.getDate();
  var currentMonth = t.getMonth();
  var currentYear = t.getFullYear();
  var currentHour = t.getHours();
  var selectedStoreId = selectedStore.storeID;  

  // Apply daily cutoff at 1:00 PM
  picker.set('min', 1); // if before 1pm allow next day pickup
  if (currentHour >= 13) {
    picker.set('min', 2);
  }
  
/* if (specialProduct12 === true) {
    var cutoffDate = new Date();
    
    picker.set('min', cutoffDate); // Set minimum selectable date
    picker.set('disable', [
        true, // Disable all dates by default
        { from: [2025, 1, 1], to: [2025, 1, 12] }, // Block orders before Feb 12th, 2025
        { from: [2025, 1, 17], to: [2025, 1, 28] }, // Block orders after Feb 16th, 2025
    ]);
}*/
 /* if (specialProduct11 === true) {
    var cutoffDate = new Date();
    if (currentHour >= 13) {
      cutoffDate.setDate(t.getDate() + 3); // 3-day lead time after 1pm
    } else {
      cutoffDate.setDate(t.getDate() + 2); // 2-day lead time if before 1pm
    }

    picker.set('min', cutoffDate); // Set minimum date based on cutoff
    picker.set('disable', [
      true,
      { from: [2023, 1, 11], to: [2024, 10, 30] },
      { from: [2024, 11, 25], to: [2034, 1, 9] },
    ]);

    console.log("Special Product 11 cutoff applied for", cutoffDate.toDateString());
  } */ 
  
  if (specialProduct4 === true) {
    picker.set('disable', [true, 1, 7]);
    picker.set('min', 2);
  }

  /*if (specialProduct7 === true) {
  	picker.set('disable', [true, 
      { from: [2020, 8, 10], to: [2025, 10, 30] }, 
      { from: [2025, 11, 25], to: [2032, 9, 7] }
    ]);
    picker.set('max', 100);   
    picker.set('min', 2);   
    jqCR('.christmas-message').html(`<strong>Once an order has been placed, please allow 48 hours as all of our specialty Christmas items are made to order.*</strong>`)
  } */
 console.log(selectedStoreId);
  if (specialProduct6 === true && (selectedStoreId === 1032 || selectedStoreId === 218 || selectedStoreId === 4601 || selectedStoreId === 6070)) {
  	picker.set('disable', [true, 
      { from: [2020, 8, 10], to: [2026, 3, 1] }, 
      { from: [2026, 3, 3], to: [2026, 3, 3] },
      { from: [2026, 3, 6], to: [2046, 3, 2] }
    ]);
    picker.set('max', 100);   
  } else {
    picker.set('min', 2);  
    picker.set('disable', blackoutdatesCollection); // Apply general blackout dates
  }
  	   
  
};
